export const getInitialState = () => ({
    fetchStatus: "initial",
    paymentCollection: undefined,
    error: undefined
});
